import {inject, Pipe, PipeTransform} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {PayoutPolicy} from '@gatewee/types/recipient-setting';

@Pipe({
  name: 'payoutPolicy',
  pure: false,
  standalone: false,
})
export class PayoutPolicyPipe implements PipeTransform {
  private readonly translate = inject(TranslateService);

  transform(value: PayoutPolicy | string | undefined | null): string {
    if (value === undefined || value === null || value === '') {
      return '';
    }
    const key = `enums.payoutPolicy.${value}`;
    const translated = this.translate.instant(key);
    return translated && translated !== key
      ? translated
      : this.translate.instant('common.unknown');
  }
}
